import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Container, Card, Button, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { PAYROLL_LIST } from 'src/utils/constants';
import { getAccessToken } from 'src/redux/login/loginReducer';
import AppLoading from 'src/components/common/AppLoading';
import { formatterPeso } from 'src/utils/utils';
import { payrollService } from 'src/services/payrollService';
import { AdministrativeServiceData } from 'src/utils/administrativeServiceUtils';

const PayrollDetailPage = () => {
    const dispatch = useDispatch();
	const { payrollId } = useParams();
    const [payrollDetail, setPayrollDetail] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const accessToken = useSelector(state => getAccessToken(state));
    const administrativeServiceData = AdministrativeServiceData();
    const foundService = administrativeServiceData?.find(
        service => service.id === payrollDetail?.administrativeServiceId
    );
    
    useEffect(() => {
        const fetchPayrollDetail = async () => {
            try {
                setIsFetching(true);
                const data = await payrollService.getPayrollById(accessToken, payrollId);
                setPayrollDetail(data);
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setIsFetching(false);
            }
        };
        if (payrollId) {
            fetchPayrollDetail();
        }
    }, [payrollId, accessToken]);

    if (isFetching) {
        return <AppLoading isLoading={isFetching} />;
    }

    if (!payrollDetail) {
        return (
            <Container fluid>
                <Card className="mb-3">
                    <Card.Header className="h6">Detalle de Liquidación de Haberes</Card.Header>
                    <Card.Body>
                        <p>No se encontraron detalles para el ID proporcionado.</p>
                        <div className="d-flex justify-content-center mt-4 mb-4">
                            <Button
                                type="button"
                                variant="primary"
                                size="lg"
                                onClick={() => dispatch(push(PAYROLL_LIST))}
                            >
                                Volver
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    return (
        <Container fluid>
            <Card className="mb-3">
                <Card.Header className="h6">Detalle de Liquidación de Haberes</Card.Header>
                <Card.Body>
                    <p>
						<strong>Nombre:</strong> {payrollDetail?.name}
					</p>
                    <p>
                        <strong>Método de Contratación:</strong> {payrollDetail?.wageLiquidationType.replace(/_/g, ' ')}
                    </p>
                    <p>
                        <strong>Servicio administrativo:</strong> {
                            foundService 
                            ? `${foundService.code} - ${foundService.name}` 
                            : payrollDetail?.administrativeServiceId || 'No disponible'
                        }
                    </p>
                    <p>
                        <strong>Observación:</strong> {payrollDetail?.description}
                    </p>
                    <p>
                        <strong>Importe Neto:</strong> {formatterPeso.format(payrollDetail?.generalAmount - payrollDetail?.netAmount)}
                    </p>
                    <p>
                        <strong>Importe Liquido:</strong> {formatterPeso.format(payrollDetail?.netAmount)}
                    </p>
                    <p>
                        <strong>Importe General:</strong> {formatterPeso.format(payrollDetail?.generalAmount)}
                    </p>
                    <Table striped hover size='sm'>
                        <thead>
                            <tr className='py-4'>
                                <th className='text-center'>Código</th>
                                <th className='text-center'>Item</th>
                                <th className='text-center'>Concepto</th>
                                <th className='text-center'>Subconcepto</th>
                                <th className='text-center'>Monto subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payrollDetail?.wageManagerDetails?.map((detail) => (
                                <tr key={detail?.id}>
                                    <td className='text-center'>{detail?.code}</td>
                                    <td>{detail?.item}</td>
                                    <td>{detail?.concept}</td>
                                    <td>{detail?.subConcept}</td>
                                    <td className='text-right pr-2'>{formatterPeso.format(detail?.subtotalAmount)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className="d-flex justify-content-center mt-5 mb-4">
                        <Button
                            type="button"
                            variant="primary"
                            size="lg"
                            onClick={() => dispatch(push(PAYROLL_LIST))}
                        >
                            Volver
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default PayrollDetailPage;